import styled from "styled-components";
import { LMS_WEBAPP_CONFIG_IMPL } from "../../../../../infecto-lms-webapp-impl/config";

export const Header = styled.div`
	color: #000;
	text-align: center;
	font-size: 20px;
	font-style: normal;
	font-weight: 600;
	line-height: 24px;
	letter-spacing: 1.2px;
	margin-bottom: 16px;
`;

export const SuccessMessage = styled.div`
	background-color: ${LMS_WEBAPP_CONFIG_IMPL.brandColor};
	padding: 10px;
	color: white;
	position: absolute;
	top: 120px;
	right: 50px;
	border-radius: 5px;
`;

export const Container = styled.div`
	margin-top: 40px;
	margin-bottom: 40px;
`;
